<template>
  <div id="user-data">
    <vx-card :title="titleCard" class="mb-base">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- <vs-input
              class="w-full mt-4"
              label="Código"
              v-model="casoId"
              v-validate="'required'"
              name="casoId"
              :disabled="true"
            />
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('casoId') || formerr.includes('casoId')
              "
              >Por favor ingrese el c&oacute;digo</span
            > -->

            <vs-input class="w-full mt-1" label="Asunto" v-model="casoAsunto" v-validate="'required'"
              name="casoAsunto" />
            <span class="text-danger text-sm" v-show="errors.has('casoAsunto') || formerr.includes('casoAsunto')
              ">Por favor ingrese el asunto</span>

            <div class="w-full mt-4">
              <label for="casoDescripcion" class="vs-input--label">Descripción</label>
              <vs-textarea class="w-full mb-0" v-model="casoDescripcion" v-validate="'required'"
                name="casoDescripcion" />
              <span class="text-danger text-sm"
                v-show="errors.has('casoDescripcion') || formerr.includes('casoDescripcion')">Por favor ingrese la
                descripci&oacute;n</span>
            </div>

            <!-- Caso proyecto  -->
            <!-- <vs-select
              v-model="casoProyectoId"
              name="casoProyectoId"
              label="Proyecto"
              class="w-full mt-5"
              :disabled="
                this.proyectoList === null ||
                this.proyectoList === undefined
              "
              @input="handleProyecto"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in proyectoList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('casoProyectoId') || formerr.includes('casoProyectoId')"
            >Por favor seleccione el proyecto</span> -->

            <!-- Proyecto -->
            <div class="w-full mt-4">
              <label class="text-sm ">Proyecto</label>
              <v-select v-model="casoProyectoId" name="casoProyectoId" label="id" class="w-full mt-1"
                :options="proyectoList" :reduce="item => item.id"
                :disabled="this.proyectoList === null || this.proyectoList === undefined" @input="handleProyecto"
                :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoProyectoId') || formerr.includes('casoProyectoId')">Por favor
                seleccione el proyecto</span>
            </div>

            <!-- Subproyecto -->
            <!-- <vs-select v-model="casoSubProyectoId" name="casoSubProyectoId" label="Subproyecto" class="w-full mt-3 mb-3"
              :disabled="this.subProyectoActive" @input="handleSubProyecto">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.id + ' - ' + item.descripcion"
                v-for="item in subProyectoList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoSubProyectoId') || formerr.includes('casoSubProyectoId')">Por favor seleccione el
              subproyecto</span> -->


            <!-- SubProyecto -->
            <div class="w-full mt-3">
              <label class="text-sm ">Subproyecto</label>
              <v-select v-model="casoSubProyectoId" name="casoSubProyectoId" label="id"
                class="w-full mt-1 mb-3" :options="subProyectoList" :reduce="item => item.id"
                :disabled="this.subProyectoActive" @input="handleSubProyecto" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoSubProyectoId') || formerr.includes('casoSubProyectoId')">Por favor seleccione
                el
                subproyecto</span>
            </div>

          </div>
        </div>

        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- <vs-select
              v-model="casoAplicativo"
              name="casoAplicativo"
              label="Aplicaciones"
              class="w-full mt-1"
              :disabled="
                this.applicacionesList === null ||
                this.applicacionesList === undefined
              "
              @input="handleApplicative"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in applicacionesList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('casoAplicativo') || formerr.includes('casoAplicativo')"
            >Por favor seleccione la aplicación</span> -->

            <!-- <vs-select
              v-model="casoHelpDesk"
              name="casoHelpDesk"
              label="Infraestructura"
              class="mt-4 w-full"
              :disabled="
                this.infraestructuraList === null ||
                this.infraestructuraList == undefined
              "
              @input="handleHelpDesk"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in infraestructuraList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('casoHelpDesk') || formerr.includes('casoHelpDesk')"
            >Por favor seleccione la infraestructura</span> -->

            <!-- Caso grupo tipo actividad -->
            <!-- <vs-select
              v-model="casoGrupoTipoActividadId"
              name="casoGrupoTipoActividadId"
              label="Grupo tipo de caso"
              class="w-full mt-1"
              :disabled="
                this.grupo_tipo_actividadActive
              "
              @input="handleGrupoTipoCaso"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in grupo_tipo_actividadList"
              />
            </vs-select> -->
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('casoGrupoTipoActividadId') || formerr.includes('casoGrupoTipoActividadId')"
            >Por favor seleccione el grupo tipo de caso</span> -->

            <!-- Caso grupo tipo actividad -->
            <div>
              <label class="text-sm ">Grupo tipo de caso</label>
              <v-select v-model="casoGrupoTipoActividadId" name="casoGrupoTipoActividadId" label="id"
                class="w-full mt-1 mb-3" :options="grupo_tipo_actividadList" :reduce="item => item.id"
                :disabled="this.grupo_tipo_actividadActive" @input="handleGrupoTipoCaso" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoGrupoTipoActividadId') || formerr.includes('casoGrupoTipoActividadId')">Por
                favor
                seleccione el grupo tipo de caso</span>
            </div>

            <!-- Caso tipo actividad -->
            <!-- <vs-select
              v-model="casoTipoActividadId"
              name="casoTipoActividadId"
              label="Tipo de caso"
              class="mt-4 w-full"
              :disabled="
                this.tipoActividadList === null ||
                this.tipoActividadList == undefined
              "
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in tipoActividadList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('casoTipoActividadId') || formerr.includes('casoTipoActividadId')"
            >Por favor seleccione el tipo de caso</span> -->

            <!-- Caso tipo de actividad -->
            <!-- Deberia tener @input @input="handleProyecto"-->
            <div>
              <label class="text-sm ">Tipo de caso</label>
              <v-select v-model="casoTipoActividadId" name="casoTipoActividadId" label="id"
                class="w-full mt-1" :options="tipoActividadList" :reduce="item => item.id" :disabled="this.tipoActividadList === null || this.tipoActividadList == undefined" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span
              class="text-danger text-sm"
              v-show="errors.has('casoTipoActividadId') || formerr.includes('casoTipoActividadId')"
            >Por favor seleccione el tipo de caso</span>
            </div>

            <!-- Cuenta -->
            <!-- <vs-select v-model="casoCuentaId" name="casoCuentaId" label="Cuenta" class="w-full mt-3 mb-3" :disabled="this.cuentaActive">
              <vs-select-item />
              <vs-select-item :key="item.id_account" :value="item.id_account" :text="item.id_account + ' - ' + item.name"
                v-for="item in cuentasList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoCuentaId') || formerr.includes('casoCuentaId')">Por favor seleccione la cuenta</span> -->

            <!-- Cuenta -->
            <!-- Deberia tener @input="handleGrupoTipoCaso" -->
            <div class="w-full mt-3">
              <label class="text-sm ">Cuenta</label>
              <v-select v-model="casoCuentaId" name="casoCuentaId" label="id" class="w-full mt-1 mb-3"
                :options="cuentasList" :reduce="item => item.id" :disabled="this.cuentaActive"
                :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoCuentaId') || formerr.includes('casoCuentaId')">Por
                favor seleccione la cuenta</span>
            </div>

            <div class="w-full mt-4">
              <label for="files" class="vs-input--label">Adjuntar archivos</label>
              <file-pond name="test" ref="pond" label-idle="Suelta los archivos aquí..." class="w-full"
                allow-multiple="true" accepted-file-types="image/jpeg, image/png" v-on:addfile="handleFilePondAddFile"
                v-on:removefile="handleFilePondRemoveFile" v-on:init="handleFilePondInit" />
            </div>

          </div>
        </div>
      </div>
    </vx-card>

    <div class="vx-col w-full flex" id="account-manage-buttons">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" @click="closeSidebar">Cancelar</vs-button>
    </div>
  </div>
</template>

<script>
//Fuse
import Fuse from 'fuse.js'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Create component
const FilePond = vueFilePond()
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
import ListasModule from '@/store/listas-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'
import { searchCompany } from '../../../config/companies.js'

export default {
  components: {
    Datepicker,
    flatPickr,
    FilePond
  },
  props: {
    casoDataProp: {
      type: Object,
      default: () => { }
    },
    createNewCasoProp: {
      type: Function
    },
    editCasoProp: {
      type: Function
    },
    closeSidebarProp: {
      type: Function
    }
  },
  data() {
    return {
      titleCard: '', // Crear/Modificar Caso
      modeCreate: true, // Crear => true/Modificar => false
      formerr: [], // Crear => true/Modificar => false
      company: null,
      casoId: null,
      casoAsunto: '',
      casoDescripcion: '',
      casoClaseCasoId: '',
      casoFuenteId: '',
      casoCompaniaId: '',
      casoProyectoId: '',
      casoSubProyectoId: '',
      casoTipoCasoId: '',
      // casoArea: this.$store.state.auth.userDetails().department || '',
      casoServicioId: null,
      casoCodigoExterno: null,
      casoTipoActividadExternaId: null,
      casoPrioridadId: null,
      casoCriticalityId: null,
      casoItilIncidentType: null,
      casoAplicativo: null,
      casoHelpDesk: null,
      casoGrupoTipoActividadId: null,
      casoTipoActividadId: null,
      casoCuentaId: null,
      prioridadList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      myFiles: [],
      user_data: {},
      user_not_found: false,
      dob: new Date(),
      fechaini: null,
      casoFechaCompromiso: null,
      configdateIni: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i ',
        locale: SpanishLocale,
        maxDate: null
        // enableSeconds: true,
      }
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.formerr.length <= 0
    },
    proyectoList() {
      return this.$store.state.ListasModule.proyecto
    },
    subProyectoList() {
      return this.$store.state.ListasModule.sub_proyecto
    },
    applicacionesList() {
      return this.$store.state.ListasModule.applicative
    },
    infraestructuraList() {
      return this.$store.state.ListasModule.help_desk
    },
    grupo_tipo_actividadActive() {
      return this.$store.state.ListasModule.grupo_tipo_actividad.length === 0
    },
    grupo_tipo_actividadList() {
      return this.$store.state.ListasModule.grupo_tipo_actividad
    },
    tipoActividadList() {
      return this.$store.state.ListasModule.tipo_actividad
    },
    cuentasList() {
      return this.$store.state.ListasModule.accounts
    },
    subProyectoActive() {
      return this.$store.state.ListasModule.sub_proyecto.length === 0
    },
    cuentaActive() {
      return this.$store.state.ListasModule.accounts.length === 0
    }
  },
  created() {

    this.company = searchCompany(this.$route.params.nameCompany)

    this.initParams()
    this.initListOfValues()
  },
  watch: {
    casoDataProp() {
      this.initParams()
    }
  },
  methods: {
    fuseSearch(options, search) {
      //console.log("Opciones disponibles:", options);
      //console.log("Término de búsqueda:", search);

      if (!search) return options;

      const fuse = new Fuse(options, {
        keys: ['id', 'descripcion'],
        threshold: 0.3,
        shouldSort: true,
      });

      const results = fuse.search(search).map(result => result.item);
      //console.log("Resultados filtrados:", results);

      return results;
    },
    initListOfValues() {
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAllProyecto', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()

          if (response.data) {
            const list = response.data.listaProyecto
            if (list) {
              if (list.length === 1) {
                const id = list[0].id
                this.casoProyectoId = id

                this.handleProyecto(id)
              }
            }
          }
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    initParams(force = false) {
      if (
        force ||
        (this.casoDataProp !== null) ||
        this.casoDataProp.id === null ||
        this.casoDataProp.id === undefined ||
        this.casoDataProp.id === ''
      ) {
        this.modeCreate = true
        this.titleCard = 'Crear caso'
        this.casoId = null
        this.casoAsunto = ''
        this.casoDescripcion = ''
        this.casoServicioId = null
        this.casoTipoActividadId = null
        this.casoCuentaId = null
        this.fechaini = null
        this.casoCodigoExterno = null
        this.casoTipoActividadExternaId = null
        this.casoPrioridadId = null
        this.casoCriticalityId = null
        this.casoItilIncidentType = null
        this.casoProyectoId = null
      } else {
        console.log(
          'Modificando, this.casoDataProp',
          this.casoDataProp
        )
        this.modeCreate = false
        this.titleCard = 'Modificar caso'
        this.casoId = this.casoDataProp.id
        this.casoAsunto = this.casoDataProp.asunto
        this.casoDescripcion = this.casoDataProp.descripcion
        this.casoServicioId = this.casoDataProp.requestTypeService ? this.casoDataProp.requestTypeService.id : 0
        this.casoTipoActividadId = this.casoDataProp.tipoActividad ? this.casoDataProp.tipoActividad.id : 0
        this.casoCuentaId = this.casoDataProp.casoCuentaId ? this.casoDataProp.casoCuentaId.id : 0
        this.fechaini = this.casoDataProp.fechaAcordada
        this.casoCodigoExterno = this.casoDataProp.USU_RESPO_NOMBRE
        this.casoTipoActividadExternaId = this.casoDataProp.tipoActividadExterna ? this.casoDataProp.tipoActividadExterna.id : 0
        this.casoPrioridadId = this.casoDataProp.prioridad
        this.casoCriticalityId = this.casoDataProp.criticality ? this.casoDataProp.criticality.id : 0
        this.casoItilIncidentType = this.casoDataProp.itilIncidentType ? this.casoDataProp.itilIncidentType.id : 0
        this.casoProyectoId = this.casoDataProp.proyecto ? this.casoDataProp.proyecto.id : 0
      }

      this.$validator.reset()
    },
    actionSaveData() {
      //console.log('this.myFiles', this.myFiles)
      //console.log('user', this.$store.state.auth.userDetails())
      //console.log('nameCompany', this.$route.params.nameCompany)

      if (!this.company) {
        alert('El nombre de la compañia no es correcto.')

        return
      }

      /*this.myFiles.forEach(element => {
        console.log('file', element.name)
      })*/

      this.formerr = []
      if (
        this.casoId === null ||
        this.casoId === undefined
      ) {
        //TODO, revisar la validación
        //this.formerr.push('casoId')
      }
      if (
        this.casoAsunto === null ||
        this.casoAsunto === undefined ||
        this.casoAsunto.trim() === ''
      ) {
        this.formerr.push('casoAsunto')
      }
      if (
        this.casoDescripcion === null ||
        this.casoDescripcion === undefined ||
        this.casoDescripcion.trim() === ''
      ) {
        this.formerr.push('casoDescripcion')
      }

      if (
        this.casoProyectoId === null ||
        this.casoProyectoId === undefined ||
        this.casoProyectoId === ''
      ) {
        this.formerr.push('casoProyectoId')
      }

      /*if (this.casoHelpDesk === null) {
        if (
          this.casoAplicativo === null ||
        this.casoAplicativo === undefined ||
        this.casoAplicativo === ''
        ) {
          this.formerr.push('casoAplicativo')
        }
      }*/

      /*if (this.casoAplicativo === null) {
        if (
          this.casoHelpDesk === null ||
        this.casoHelpDesk === undefined ||
        this.casoHelpDesk === ''
        ) {
          this.formerr.push('casoHelpDesk')
        }
      }*/
      if (!this.grupo_tipo_actividadActive) {
        if (
          this.casoGrupoTipoActividadId === null ||
          this.casoGrupoTipoActividadId === undefined
        ) {
          this.formerr.push('casoGrupoTipoActividadId')
        }
      }
      if (
        this.casoTipoActividadId === null ||
        this.casoTipoActividadId === undefined ||
        this.casoTipoActividadId === ''
      ) {
        this.formerr.push('casoTipoActividadId')
      }

      if (!this.cuentaActive) {
        if (
          this.casoCuentaId === null ||
          this.casoCuentaId === undefined ||
          this.casoCuentaId === ''
        ) {
          this.formerr.push('casoCuentaId')
        }
      }

      if (this.validateForm) {

        //console.log('this.casoAplicativo', this.casoAplicativo)
        //console.log('this.casoHelpDesk', this.casoHelpDesk)

        const casoDataProp = {
          id: -1, //this.casoId,
          company: { id: this.company.idCompany, descripcion: '' },
          tipoActividadExterna: { id: 104/*this.casoTipoActividadExternaId*/, idCompania: this.company.idCompany, descripcion: '' },
          codigoInterno: -1/*this.casoCodigoExterno*/,
          descripcion: this.casoDescripcion,
          prioridad: 5, //this.casoPrioridadId,
          groupTipCaso: this.grupo_tipo_actividadActive ? null : { id: this.casoGrupoTipoActividadId, descripcion: '' },
          tipoActividad: { id: /*12*/this.casoTipoActividadId, idCompania: this.company.idCompany, descripcion: '' },
          usuario: this.$store.state.auth.userDetails().id, // 279,
          proyecto: { id: this.casoProyectoId, idCompania: this.company.idCompany, descripcion: '' },
          subproyecto: { id: this.casoSubProyectoId, idCompania: null, descripcion: '' },
          usuarioAsignado: { id: this.$store.state.auth.userDetails().id, name: this.$store.state.auth.userDetails().name },
          fechaAcordada: null/*this.fechaini*/,
          criticality: { id: 4/*this.casoCriticalityId*/, descripcion: '' },
          itilIncidentType: { id: 1/*this.casoItilIncidentType*/, descripcion: '' },
          requestTypeService: { id: -1/*this.casoServicioId*/, descripcion: '' },
          app: { id: null /*this.casoAplicativo*/, descripcion: '' },
          helpDeskService: { id: null/*this.casoHelpDesk*/, descripcion: '' },
          subject_req: this.casoAsunto,
          area: { id: 1, /*descripcion: this.casoArea*/ descripcion: '' },
          source: { id: 1, descripcion: '' },
          myFiles: this.myFiles,
          gesActivo: null,
          cuenta: { id: this.casoCuentaId }
        }

        console.log("New Request", casoDataProp)

        if (this.modeCreate) {
          this.createNewCasoProp(casoDataProp)
        } else {
          this.editCasoProp(casoDataProp)
        }
      } else {
        console.log('Hay errores que resolver', this.errors)
      }
    },
    handleProyecto(item) {
      //console.log('handleProyecto item, ', item)

      this.casoGrupoTipoActividadId = null
      this.casoTipoActividadId = null
      this.casoCuentaId = null

      this.$store.dispatch('ListasModule/clearAllSubProyecto')
      this.$store.dispatch('ListasModule/clearAllApplicative')
      this.$store.dispatch('ListasModule/clearAllHelpDesk')
      this.$store.dispatch('ListasModule/clearAllGrupoTipoActividad')
      this.$store.dispatch('ListasModule/clearAllTipoActividad')

      if (item) {
        const companyTemp = this.company
        companyTemp.idProject = item
        //companyTemp.idGrupoRequestType = -1
        console.log('companyTemp', companyTemp)

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllSubProyecto', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllApplicative', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllHelpDesk', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllGrupoTipoActividad', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
          .then((response) => {
            this.$vs.loading.close()

            if (response.data) {
              if (response.data.listaGroupTipCaso.length === 0) {
                this.handleGrupoTipoCaso(-1)
              }
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        /*this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividad', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })*/

      }
    },
    handleSubProyecto() {
      //console.log('handleSubProyecto item, ', item)
      this.casoCuentaId = null

      this.$store.dispatch('ListasModule/clearAccountByFilter')

      const dataTmp = {
        idCompany: this.company.idCompany,
        idProject: this.casoProyectoId,
        idSubProject: this.casoSubProyectoId
      }

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAccountByFilter', dataTmp)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    handleGrupoTipoCaso(item) {
      //console.log('handleGrupoTipoCaso item, ', item)

      this.casoTipoActividadId = null
      this.casoCuentaId = null

      this.$store
        .dispatch('ListasModule/setAllTipoActividad', { lista: [] })

      if (item !== null) {
        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividad', { ...this.company, idGrupoRequestType: item })
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleApplicative() {
      this.casoHelpDesk = null
    },
    handleHelpDesk() {
      this.casoAplicativo = null
    },
    handleFilePondInit() {
      console.log('FilePond has initialized')

      // FilePond instance methods are available on `this.$refs.pond`
    },
    handleFilePondAddFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.push(file.file)

    },
    handleFilePondRemoveFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.map((item, index) => {
        if (item.name === file.filename) {
          this.myFiles.splice(index, 1)
        }
      })
    },
    closeSidebar() {
      this.closeSidebarProp()
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configdateIni, 'maxDate', dateStr)
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>

<style lang="scss">
.vs-textarea {
  font-size: 1rem;
  color: inherit;
  font-family: sans-serif;
  height: 110px;
  line-height: 1.5;
}
</style>
